import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register/registerLayout.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/editor/:_id',
    name: 'data-editor',
    component: () => import('../views/DataEditor.vue')
  },
  {
    path: '/undeleted-pages',
    name: 'undeleted-pages',
    component: () => import('../views/UnDeletedPage.vue')
  },
  {
    path: '/sensitive-area-keywords',
    name: 'sensitive-area-keywords',
    component: () => import('../views/SensitiveAreaKeyword.vue')
  },
  {
    path: '/export',
    name: 'data-export',
    component: () => import('../views/DataExport/DataExport.vue')
  },
  {
    path: '/',
    name: 'record-chunk',
    component: () => import('../views/RecordChunk.vue')
  },
  {
    path: '/usermanagement',
    name: 'user-management',
    component: () => import('../views/UserManagement.vue')
  },
  {
    path: '/usermanagement/:id/edit',
    name: 'user-management-edit',
    component: () => import('../views/user_management/EditUser.vue')
  },
  {
    path: '/password',
    name: 'password',
    component: () => import('../views/Password.vue')
  },
  {
    path: '/tests/editor/:_id',
    name: 'tests_editor',
    component: () => import('../views/test/TestDataEditor.vue')
  },
  {
    path: '/accuracy-analytic',
    name: 'accuracy-analytic',
    component: () => import('../views/excel/AccuracyAnalytic.vue')
  },
  {
    path: '/team-performance',
    name: 'team-performance',
    component: () => import('../views/team_performance/TeamPerformance.vue')
  }
  // {
  //   path: '/category-summary',
  //   name: 'category-summary',
  //   component: () => import('../views/CategorySummary.vue')
  // }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (
    !store.state.isAuth &&
    !['login', 'register', 'tests_editor'].includes(to.name)
  ) {
    next('/login')
  } else {
    if (store.state.isAuth && ['login', 'register'].includes(to.name)) {
      next('/')
    } else {
      next()
    }
  }
})

export default router
